module.exports = __webpack_public_path__ + "static/media/nounLayers.0825b420.svg";